import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import PhoneInput from 'react-phone-input-2'
import AxiosService from "../services/axios.service";

const API_PATH = "contacts";

const GOOGLE_MAP_API_KEY = "AIzaSyA8oEXVIh8RoYuGQO-J0-iMEAL0wQGYSU8";

const loadGoogleMapScript = (callback) => {
    if (
        typeof window.google === "object" &&
        typeof window.google.maps === "object"
    ) {
        callback();
    } else {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
        window.document.body.appendChild(googleMapScript);
        googleMapScript.addEventListener("load", callback);
    }
};

function AddEdit({ history, match }) {

    const placeInputRef = useRef(null);
    const { id } = match.params;
    const isAddMode = !id;

    // form validation rules 
    const validationSchema = Yup.object().shape({
        title: Yup.string(),
        name: Yup.string()
            .required('contact name is required'),
        street_address: Yup.string(),
        city: Yup.string(),
        state: Yup.string(),
        zip: Yup.string(),
        primary_phone: Yup.string(),
        secondary_phone: Yup.string(),
        fax: Yup.string(),
        email: Yup.string(),
        agency_name: Yup.string()
    });

    // functions to build form returned by useForm() hook
    const { register, watch, handleSubmit, reset, setValue, errors, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    function onSubmit(data) {
        return isAddMode
            ? createContact(data)
            : updateContact(id, data);
    }

    function createContact(data) {
        return AxiosService.create(API_PATH, data)
            .then(() => {
                //handle email already in use
                console.log(data);
                history.push('.');
            })
    }

    function updateContact(id, data) {
        return AxiosService.update(API_PATH, id, data)
            .then(() => {
                history.push('..');
            })
    }

    function selectAddress(place) {
        console.log(place.formatted_address);
        var address_fields = place.formatted_address.split(",");

        setValue("street_address", address_fields[0]);
        setValue("city", address_fields[1]);
        setValue("state", address_fields[2]);
        setValue("zip", address_fields[3]);
    }

    const initPlaceAPI = () => {
        let autocomplete = new window.google.maps.places.Autocomplete(
            placeInputRef.current
        );
        new window.google.maps.event.addListener(
            autocomplete,
            "place_changed",
            function () {
                selectAddress(autocomplete.getPlace());
            }
        );
    };

    useEffect(() => {

        register("address");
        register("street");
        register("city");
        register("state");
        register("zip");

        register("primary_phone");
        register("secondary_phone");
        register("fax");

        loadGoogleMapScript(() => {
            initPlaceAPI();
        });

        if (!isAddMode) {
            // get contact and set form fields
            AxiosService.get(API_PATH, id).then(x => {
                var contact = x.data;
                const fields = ['title', 'name', 'street_address', 'city', 'state', 'zip', 'primary_phone', 'secondary_phone', 'fax', 'email', 'agency_name'];
                fields.forEach(field => setValue(field, contact[field]));
                setValue("primary_phone", 1 + watch("primary_phone"));
                setValue("secondary_phone", 1 + watch("secondary_phone"));
                setValue("fax", 1 + watch("fax"));
            });
        }
    }, []);

    const onFocus = event => {
        if (event.target.autocomplete) {
            event.target.autocomplete = "whatever";
        }
    };

    return (
        <form onFocus={onFocus} onSubmit={handleSubmit(onSubmit)} onReset={reset}>
            <h1>{isAddMode ? 'Add Contact' : 'Edit Contact'}</h1>
            <div className="form-row">
                <div className="form-group col-5">
                    <label>Title</label>
                    <input autoComplete="off" name="title" type="text" ref={register} className={`form-control ${errors.title ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.title?.message}</div>
                </div>
                <div className="form-group col-5">
                    <label>Agency Contacts Name</label>
                    <input autoComplete="off" name="name" type="text" ref={register} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.name?.message}</div>
                </div>
            </div>

            <div className="form-row">
                <div className="form-group col-5">
                    <label>Address</label>
                    <input autoComplete="off" value={watch("address")} name="address" type="text" ref={placeInputRef} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.case_name?.message}</div>
                </div>
            

       
            <div className="form-group col-5">
                    <label>Primary Phone number:</label>
                    <input autoComplete="off" name="primary_phone" type="text" ref={register} className={`form-control ${errors.primary_phone ? 'is-invalid' : ''}`} />                    <div className="invalid-feedback">{errors.case_name?.message}</div>
                    </div>

                </div>

            <div className="form-row">
                <div className="form-group col-5">
                    <label>Secondary Phone number:</label>
                    <input autoComplete="off" name="secondary_phone" type="text" ref={register} className={`form-control ${errors.secondary_phone ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.case_name?.message}</div>
                </div>
       
            
       
                <div className="form-group col-5">
                    <label>Fax:</label>
                    <input autoComplete="off" name="fax" type="text" ref={register} className={`form-control ${errors.fax ? 'is-invalid' : ''}`} />                    <div className="invalid-feedback">{errors.case_name?.message}</div>
                </div>
            </div>

            <div className="form-row">
           
                <div className="form-group col-5">
                    <label>Email</label>
                    <input autoComplete="off" name="email" type="text" ref={register} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.email?.message}</div>
                </div>
        
        
                <div className="form-group col-5">
                    <label>Agency Name</label>
                    <input autoComplete="off" name="agency_name" type="text" ref={register} className={`form-control ${errors.agency_name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.agency_name?.message}</div>
                </div>
            </div>
            <div className="form-group">
                <button type="submit" disabled={formState.isSubmitting} className="btn btn-primary">
                    {formState.isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                    Save
                </button>
                <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
            </div>
        </form>
    );
}

export { AddEdit };